import { apiClient } from '@/lib/api/client';
import { getDataOrThrowApiError } from '@/lib/api/error';
import { MAX_PAGE_SIZE } from '@/lib/api/max-page-size';
import { DEPARTMENT_QUERY_KEY } from './key';
import type { DepartmentItem } from './type';
export const fetchDepartments = async (freeText: string, excludeIds: string[] = []): Promise<DepartmentItem[]> => {
  const res = await apiClient.GET(DEPARTMENT_QUERY_KEY, {
    params: {
      query: {
        freeText,
        excludeIds,
        pageSize: MAX_PAGE_SIZE
      }
    }
  });
  const data = getDataOrThrowApiError(res);
  return data.items;
};